import { Breadcrumb, Button, Table } from "antd";
import styles from "./List.module.scss";
import { _adr } from "../../../address";
import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Content } from "antd/es/layout/layout";
import { NotFound } from "../../../sources/svg/svg";
import { useEffect, useState } from "react";
import Loading from "../../auxiliary/loader/loading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDealer } from "../../../tools/api";
import { use } from "i18next";
import { convertToJalaliWithTime } from "../../../tools/tools";
import TablesPurchase from "./tables/tables";
import ViewPurchase from "./tabs/tabs";
const ResultSearch360 = () => {
	const [t] = useTranslation("global");
	const nav = useNavigate();

	const { queryCountSimCardByCertNo, queryActiveSPPurchaseByCertNoVMSISDN } = useDealer();

	//state current page show Records
	const [currentPage, setCurrentPage] = useState(10);
	// state totalRecord
	const [totalRecord, setTotalRecord] = useState(0);

	//total has simcard
	const [counterSim, setCounterSim] = useState(-1);

	//loading
	const [loading, setLoading] = useState(false);

	const [selectProfile, setSelectProfile] = useState({});

	const [resultSearch, setResultSearch] = useState([]);

	const location = useLocation();

	const [tabView, setTabView] = useState(false);

	const [sppurchaseid, setSppurchaseid] = useState(0);

	useEffect(() => {
		const initial = async () => {
			if (location?.state?.certno && location?.state?.msisdn) {
				const payload = {
					certtype: location?.state?.certtype,
					certno: location?.state?.certno,
				};
				const response = await queryCountSimCardByCertNo(payload);
				if (response !== null) {
					setCounterSim(response);

					const payloadPurchase = {
						msisdn: location?.state?.msisdn,
						certno: location?.state?.certno,
					};
					const responsePurchase = await queryActiveSPPurchaseByCertNoVMSISDN(payloadPurchase);
					if (responsePurchase) {
						const firstPurchase = responsePurchase.Result[0];
						setSelectProfile(firstPurchase);
						setResultSearch(responsePurchase.Result);
					}
				}
			} else {
				nav(_adr.Root + _adr.Services360.Index);
			}
		};
		initial();
	}, []);

	const handleCallBack = (sppurchaseid) => {
		setSppurchaseid(sppurchaseid);
		setTabView(true);
	};
	return (
		<>
			<div className={`container-main ${styles.container_list}`}>
				<div className="g-hold-title-of-page">
					<Breadcrumb className="breadcrumbs" items={[{ href: _adr.Root + _adr.Home, title: <HomeOutlined /> }, { title: t("services360.title") }]} />
					<div className="title-page">
						<h3>{t("services360.title")}</h3>
						<p></p>
					</div>
				</div>
				<div className="g-layout-content">
					<Content className={`g-layout-main ${styles.list_container} `}>
						<div className="g-format-page">
							<div className="g-body-format-page">
								<div className={styles.profile}>
									<div className={styles.row}>
										<div className={styles.prof_role}>
											<div className={styles.row_item}>
												<div className={styles.avatar}>
													<i className="icon-user"></i>
												</div>
												<div className={styles.text_prof}>
													<span className={styles.name}>{`${selectProfile?.firstName || "-"} ${selectProfile?.lastName || "-"}`}</span>
													<div className={styles.row_name}>
														<h3>{selectProfile?.msisdn}</h3>
														<div className={`${styles.state} ${styles.success} ${styles.fail}`}>{selectProfile?.msisdnStatusTypeString || "-"}</div>
														<div className={`${styles.sim_state}`}>سیم کارت {selectProfile?.msisdnSimcardTypeString || "-"}</div>
													</div>
													{counterSim !== -1 && (
														<div className={styles.has_sim}>{counterSim} سیم‌کارت در کلیه اپراتورها به نام این کدملی ثبت شده است.</div>
													)}
												</div>
											</div>
										</div>
										<div className={styles.action_role}>
											<div className={`hold-button`}>
												<Button onClick={() => nav(_adr.Root + _adr.Services360.Index)} className={`btn-normal btn-green`}>
													جستجو مجدد
												</Button>
											</div>
										</div>
									</div>
								</div>
								{tabView ? (
									<ViewPurchase sppurchaseid={sppurchaseid} msisdn={selectProfile?.msisdn} type={selectProfile?.msisdnSimcardType} />
								) : (
									<TablesPurchase resultSearch={resultSearch} callback={handleCallBack} />
								)}
							</div>
						</div>
					</Content>
				</div>
			</div>
			<Loading isOpen={loading} />
		</>
	);
};

export default ResultSearch360;
